import { ApostleFilterInput, ApostleSortBy } from '@apeiron/apostle'
import { SortInput } from '@apeiron/common'
import { useAccountContext } from '@apeiron/temp'
import ActivityTypeFilter from '@src/components/apostles/list/filter/ActivityTypeFilter'
import ApostleClassFilter from '@src/components/apostles/list/filter/ApostleClassFilter'
import ApostleOtherFilter from '@src/components/apostles/list/filter/ApostleOtherFilter'
import ApostleSkillFilter from '@src/components/apostles/list/filter/ApostleSkillFilter'
import SaveFilter from '@src/components/share/filter/saveFilter/SaveFilter'
import { FavoriteType } from '@src/constants/favoriteFilter'
import { FC, useCallback } from 'react'

const ApostleFilter: FC<Props> = (props: Props) => {
  const {
    allowActivityFilter = false,
    allowFavorite = true,
    filterInput,
    sortInput,
    onFilterChange
  } = props

  const { isLoggedIn } = useAccountContext()

  const handleOnFilterByFavorite = useCallback(
    (filter: ApostleFilterInput, sort: SortInput<ApostleSortBy>) => {
      onFilterChange(filter, sort)
    },
    [onFilterChange]
  )

  return (
    <>
      {allowFavorite && isLoggedIn && (
        <SaveFilter
          filterInput={filterInput}
          sortInput={sortInput}
          type={FavoriteType.Apostle}
          onFilterByFavorite={handleOnFilterByFavorite}
        />
      )}
      <ApostleClassFilter
        filterInput={filterInput}
        onFilterChange={onFilterChange}
      />
      <ApostleSkillFilter
        filterInput={filterInput}
        onFilterChange={onFilterChange}
      />
      <ApostleOtherFilter
        filterInput={filterInput}
        onFilterChange={onFilterChange}
      />
      {allowActivityFilter && (
        <ActivityTypeFilter
          filterInput={filterInput}
          onFilterChange={onFilterChange}
        />
      )}
    </>
  )
}

type Props = {
  allowActivityFilter?: boolean
  allowFavorite?: boolean
  filterInput: ApostleFilterInput
  sortInput: SortInput<ApostleSortBy>
  onFilterChange: (
    input: ApostleFilterInput,
    sort?: SortInput<ApostleSortBy>
  ) => void
}

export default ApostleFilter
